import styled from 'styled-components/macro'

export const Image = styled.img`
  width: 2.8rem;
  height: 2.8rem;
  border: none;
  border-radius: 50%;
  user-select: none;
`

export const Emoji = styled.span`
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  width: 2.8rem;
  height: 2.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border: 0;
  font-size: 100%;
  line-height: normal;
  text-align: left;
  vertical-align: baseline;
  border: none;
  border-radius: 50%;
  overflow: hidden;
  user-select: none;
`
